import { autoinject } from "aurelia-framework";

@autoinject
export class CountdownTimer {
  public totalSeconds: number = 180;
  public timer: string = "3:00";
  public isResend: boolean = true;
  public timerInterval: any = null;

  public startTimer() {
    this.stop();
    this.isResend = false;
    this.updateUiTimer();
    this.timerInterval = window.setInterval(() => {
      this.totalSeconds--;
      this.updateUiTimer();
      if (this.totalSeconds <= 0) {
        this.isResend = true;
        this.stop();
      }
    }, 1000);
  }

  public setTimer(seconds:number = 180){
    this.totalSeconds = seconds;
    this.startTimer()
  }

  public updateUiTimer() {
    const minutes = String(Math.floor(this.totalSeconds / 60)).padStart(2, '0');
    const seconds = String(this.totalSeconds % 60).padStart(2, '0');
    this.timer = `${minutes}:${seconds}`;
  }

  public stop(){
    if(this.timerInterval){
        clearInterval(this.timerInterval);
        this.timerInterval = null;
    }
  }
}
